import React from 'react';
import IconButton from '../../common/IconButton';
import axios from 'axios';
import { DepartmentReferenceType, TimeEntryType } from '../../../pages/company_operations/time_administration/types';
import dayjs from 'dayjs';
import AxiosConfig from '../../../utilities/AxiosConfig';
import AddTime from './AddTime';
export interface IProps {
    departments: {
        [key: string]: Array<TimeEntryType>
    } | null;
    departmentName: any; //? This is actually the departmentid
    allowedDepartments: Array<any>;
    date: any;
    refreshEmployee: any;
    employeeId: string | number;
    showAdd?: boolean;
    showAddDefault?: boolean;
    inUsePC?: any;
}

const ActionButtons: React.FC<IProps> = (props: IProps) => {
    const { departments, departmentName, allowedDepartments, showAdd, showAddDefault, inUsePC } = props;
    const [performingAction, setPerformingAction] = React.useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);

    const approveTime = (timeEntry: any) => {
        //console.log("Time Entry: ", timeEntry);
        const { EmployeeId, ProfitCenterId, EntryDate } = timeEntry[0];
        // Employee Id of entry
        setPerformingAction(true);
        axios.get(process.env.REACT_APP_API_URL +
            `/api/timeadmin/approvetime/${EmployeeId}/${ProfitCenterId}/${departmentName}/${dayjs(EntryDate).format("MM-DD-YYYY")}`,
            AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log("Approve Response: ", res);
                if (AxiosConfig.checkResponse(res)) {

                    props.refreshEmployee();
                }
            })
            .catch((err: any) => {
                //console.log("Approve Err: ", err, err.response)
            })
            .finally(() => { setPerformingAction(false); });
    }

    // Adding outside of departments not allowed
    // No duplicate field entry id 
    // Decide on color scheme for internal and external 
    // Test addEDIT
    // what the fuck is happening here and here       
    // cannot approve exported or already approved times
    // unapprove something that unapproved, and not exported
    // AddEdit -> Never be able to change department
    // Timecodes that haven't been entered that day, changes by department                          

    const unapproveTime = (timeEntry: any) => {
        const { EmployeeId, ProfitCenterId, EntryDate } = timeEntry[0];
        setPerformingAction(true);
        axios.get(process.env.REACT_APP_API_URL +
            `/api/timeadmin/unapprovetime/${EmployeeId}/${ProfitCenterId}/${departmentName}/${dayjs(EntryDate).format("MM-DD-YYYY")}`,
            AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log("Unapprove Response: ", res);
                if (AxiosConfig.checkResponse(res)) {
                    props.refreshEmployee();
                }
            })
            .catch((err: any) => {
                //console.log("unapprove Err: ", err, err.response)
            })
            .finally(() => { setPerformingAction(false); });
    }

    const closeAdd = () => {
        setModalOpen(false);
    }

    React.useEffect(() => {
        //console.log("ActionButtons: ", props);
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [])

    if (showAdd) {
        let departmentID: any = allowedDepartments.find((dept: DepartmentReferenceType) => dept.ProfitCenterId === departmentName)?.DepartmentId;
        return (
            <>
                <IconButton
                    icon="add_circle"
                    iconClassName="text-orange"
                    buttonClassName="action-text"
                    onClick={(e: any) => { e.preventDefault(); setModalOpen(true); }}
                >
                    Add Time
                </IconButton>
                <AddTime
                    employeeId={props.employeeId}
                    refreshEmployee={props.refreshEmployee}
                    date={props.date}
                    departmentId={departmentID}
                    departments={allowedDepartments}
                    open={modalOpen}
                    closeModal={closeAdd}
                    inUsePC={inUsePC}
                />
            </>
        )
    }

    if (showAddDefault) {
        return (
            <>
                <IconButton
                    icon="add_circle"
                    iconClassName="text-orange"
                    buttonClassName="action-text"
                    onClick={(e: any) => { e.preventDefault(); setModalOpen(true); }}
                >
                    Add Time
                </IconButton>
                <AddTime
                    employeeId={props.employeeId}
                    refreshEmployee={props.refreshEmployee}
                    date={props.date}
                    departmentId={departmentName}
                    departments={allowedDepartments}
                    open={modalOpen}
                    closeModal={closeAdd}
                    inUsePC={inUsePC}
                />
            </>
        )
    }

    return (
        <div className="d-flex flex-row align-items-center">
            {
                departments
                    ?
                    <>
                        {
                            departments[departmentName].length
                                ?
                                <>
                                    {!departments[departmentName][0].ApprovedBy ?
                                        <>
                                            <IconButton // Approve Button
                                                onClick={(e: React.SyntheticEvent) => { e.preventDefault(); approveTime(departments[departmentName]) }}
                                                showSpinner={performingAction}
                                                icon="check_circle"
                                                iconClassName="text-success"
                                                buttonClassName="action-text">Approve</IconButton>
                                            <IconButton
                                                icon="add_circle"
                                                iconClassName="text-orange"
                                                buttonClassName="action-text"
                                                onClick={(e: any) => { e.preventDefault(); setModalOpen(true); }}
                                            >Add Time</IconButton>
                                        </> : null}

                                    {departments[departmentName][0].ApprovedBy ?
                                        <IconButton // Unapprove Button
                                            onClick={(e: React.SyntheticEvent) => { e.preventDefault(); unapproveTime(departments[departmentName]) }}
                                            showSpinner={performingAction}
                                            icon="cancel"
                                            iconClassName="text-danger"
                                            buttonClassName="action-text">Unapprove</IconButton> : null}
                                </>
                                : null
                        }
                        <AddTime
                            employeeId={props.employeeId}
                            refreshEmployee={props.refreshEmployee}
                            date={props.date}
                            departmentId={departmentName}
                            departments={allowedDepartments}
                            open={modalOpen}
                            closeModal={closeAdd}
                            inUsePC={inUsePC}
                        />
                    </>
                    : null
            }
        </div>
    );
}

ActionButtons.defaultProps = {
    showAdd: false,
    showAddDefault: false
}

export default ActionButtons;